import React, { Component } from 'react';
import Loadable from 'react-loadable';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { setupSocket } from '../_utils/socket';
import * as actions from '../actions';
import requireAuth from './_common/require-auth';
import { history } from '../_utils/history';
import withTracker from '../_utils/with-tracker';

function Loading(props) {
  if (props.error) {
    return (
      <div>
        Error! <button onClick={props.retry}>Retry</button>
      </div>
    );
  } else if (props.timedOut) {
    return (
      <div>
        Taking a long time... <button onClick={props.retry}>Retry</button>
      </div>
    );
  } else if (props.pastDelay) {
    return <div>Loading...</div>;
  } else {
    return null;
  }
}

const Home = Loadable({
  loader: () => import('./home/home'),
  loading: Loading
});


const Join = Loadable({
  loader: () => import('./join/join'),
  loading: Loading
});

const PrivacyPolicy = Loadable({
  loader: () => import('./privacy-policy/privacy-policy'),
  loading: Loading
});

const ReturnRules = Loadable({
  loader: () => import('./return-rules/return-rules'),
  loading: Loading
});

const TermsOfUse = Loadable({
  loader: () => import('./terms-of-use/terms-of-use'),
  loading: Loading
});

const Restaurants = Loadable({
  loader: () => import('./restaurants/restaurants'),
  loading: Loading
});

const AmericanDreamRestaurants = Loadable({
  loader: () => import('./american-dream-restaurants/american-dream-restaurants'),
  loading: Loading
});

const Restaurant = Loadable({
  loader: () => import('./restaurant/restaurant'),
  loading: Loading
});

const ForgotPassword = Loadable({
  loader: () => import('./auth/forgot-password'),
  loading: Loading
});

const ResetPassword = Loadable({
  loader: () => import('./auth/reset-password'),
  loading: Loading
});

const VerifyEmail = Loadable({
  loader: () => import('./auth/verify-email'),
  loading: Loading
});

const Checkout = Loadable({
  loader: () => import('./checkout/checkout'),
  loading: Loading
});

const OrderStatusPage = Loadable({
  loader: () => import('./order-status/order-status-page'),
  loading: Loading
});

const AccountPayment = Loadable({
  loader: () => import('./account/account.payment'),
  loading: Loading
});

const AccountRefer = Loadable({
  loader: () => import('./account/account.refer'),
  loading: Loading
});

const AccountUpdate = Loadable({
  loader: () => import('./account/account.update'),
  loading: Loading
});

const AccountRewards = Loadable({
  loader: () => import('./account/rewards/account.rewards'),
  loading: Loading
});

const AccountOrders = Loadable({
  loader: () => import('./account/orders/account.orders'),
  loading: Loading
});

const AccountFriends = Loadable({
  loader: () => import('./account/friends/account.friends'),
  loading: Loading
});

const AccountFindFriends = Loadable({
  loader: () => import('./account/friends/account.friends.find-friends'),
  loading: Loading
});

const BannerRestanrants = Loadable({
  loader: () => import('./banner/restaurants'),
  loading: Loading
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { initDone: false };
  }

  onFocus() {
    if (this.props.authenticated === true) {
      this.props.fetchOrderInvite(this.props.customer.id);
    }
  }

  componentWillMount() {
    window.addEventListener('focus', this.onFocus.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('focus', this.onFocus.bind(this));
  }

  componentDidMount() {
    setupSocket();
    this.props.setLocale(() => {
      this.setState({ initDone: true });
    });
  }

  render() {
    return (
      this.state.initDone && (
        <Router history={history}>
          <div className="u-full-height">
            <Switch>
              {/* <Route exact path="/" component={withTracker(Home)} /> */}
              {/* <Route
                exact
                path="/signup/:referralCode?"
                component={withTracker(Home)}
              /> */}
             
              <Route
                exact
                path="/join/:joinToken"
                component={withTracker(Join)}
              />
              <Route exact path="/privacy" component={PrivacyPolicy} />
              <Route exact path="/returnrules" component={ReturnRules} />
              <Route exact path="/terms" component={TermsOfUse} />
              {/* <Route
                exact
                path="/tiendas"
                component={withTracker(Restaurants)}
              /> */}
              {/* <Route
                exact
                path="/americandreamrestaurants"
                component={withTracker(AmericanDreamRestaurants)}
              /> */}
              {/* <Route
                exact
                path="/restaurant/:restaurantName/:restaurantId"
                component={withTracker(Restaurant)}
              /> */}
              {/* <Route exact path="/checkout" component={withTracker(Checkout)} /> */}
              <Route
                exact
                path="/forgot-password"
                component={withTracker(ForgotPassword)}
              />
              <Route
                exact
                path="/reset-password/:resetToken"
                component={ResetPassword}
              />
              <Route
                exact
                path="/verify-email/:email?/:token?"
                component={VerifyEmail}
              />
              {/* <Route
                exact
                path="/order/:orderId"
                component={withTracker(OrderStatusPage)}
              /> */}
              {/* <Route
                exact
                path="/account/payment"
                component={requireAuth(AccountPayment)}
              /> */}
              {/* <Route
                exact
                path="/account/refer"
                component={requireAuth(AccountRefer)}
              /> */}
              {/* <Route
                exact
                path="/account/update"
                component={requireAuth(AccountUpdate)}
              />
              <Route
                exact
                path="/account/friends"
                component={requireAuth(AccountFriends)}
              /> */}
              {/* <Route
                exact
                path="/account/friends/find"
                component={requireAuth(AccountFindFriends)}
              /> */}
              {/* <Route
                exact
                path="/account/orders"
                component={requireAuth(withTracker(AccountOrders))}
              /> */}
              {/* <Route
                exact
                path="/account/rewards/:currentTab?"
                component={requireAuth(withTracker(AccountRewards))}
              /> */}
              <Route exact path="/banner/restaurants/:bannerId" component={withTracker(BannerRestanrants)} />
              <Redirect to="/" />
            </Switch>
          </div>
        </Router>
      )
    );
  }
}

function mapStateToProps({ auth }) {
  return {
    authenticated: auth.authenticated,
    customer: auth.profile.customer
  };
}

export default connect(
  mapStateToProps,
  actions
)(App);
